import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/comment/CommentForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/post/PostEditButtonLazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostImage"] */ "/app/components/ui/PostImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
